import Separator from '@doordash/component-separator'
import { Inset, Spacing, StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'
import styled from 'styled-components'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../../i18n'
import { IStep, Step } from '../Step'
import { config } from './config'

export type IStepByStep = IStep | IStepWithSection

const StepSeparator = styled(Separator)`
  padding-left: 0px;
`
interface IStepWithSection {
  title: i18nKeys
  sections?: IStep[]
}

interface IStepByStepProps {
  step: number
  total: number
}

function StepWithSection({ title, sections }: IStepWithSection) {
  return (
    <StackChildren>
      <Step title={title} />
      {sections.map((section, index) => {
        const isLast = index === sections.length - 1
        return (
          <>
            <Step key={section.title} {...section} isSection />
            {!isLast && (
              <StepSeparator
                type={Separator.Types.InsetBorder}
                verticalMargin={Spacing.Large}
              />
            )}
          </>
        )
      })}
    </StackChildren>
  )
}

export function StepByStep({ step, total }: IStepByStepProps) {
  const stepConfig = config[step]

  return (
    <div>
      <Text styles={Text.Styles.Caption1} color={Text.Colors.TextTertiary}>
        {i18n.t(i18nKeys.backgroundCheck__abnHowTo__stepOf, {
          current: step,
          total,
        })}
      </Text>
      {stepConfig.sections ? (
        <StepWithSection {...stepConfig} />
      ) : (
        <Step {...stepConfig} />
      )}
      <Inset />
    </div>
  )
}
